<template>
  <Home />
</template>

<script>
import Home from '@/pages/Home.vue'

const halfmoon = require('halfmoon')

export default {
  name: 'App',
  components: {
    Home,
  },
  mounted() {
    halfmoon.onDOMContentLoaded()
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
